//--------------------------------------------------------------------------------------------------
//# Imports

import React, { useEffect, useMemo, useState } from "react";
import { usePrivy } from "@privy-io/react-auth";

import './alchmizerbatches.css'

import AlchmizerOperator from "./../../scripts/AlchmizerOperator.js";
import loading_placeholder from '../../image/loading.png';









//--------------------------------------------------------------------------------------------------
//# Variables

// let batch_info = {'BID': false,
//                   'batch_name': false,
//                   'total_quantity': 0,
//                   'quantity_generated': 0,
//                   'AID_list': [],
//                   'image_URL_list': []};

let settings = {'images_per_page': 20}

let selected_BID = false;
let batch_info = {};
let avatar_list = [];
let gallery_page = 1;

//AppStart
export default function AlchmizerBatches() {
  const { getAccessToken, ready, authenticated } = usePrivy();

  const [batches, setBatches] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");












//--------------------------------------------------------------------------------------------------
//# Functions

  const sortedBatches = useMemo(() => {
    return [...batches].sort((a, b) => {
      const ta = new Date(a?.createdAt || 0).getTime();
      const tb = new Date(b?.createdAt || 0).getTime();
      return tb - ta; // newest first
    });
  }, [batches]);


  function handleMouseOver(event) {
    // console.log('\nAlchmizeBatches.js >>> RUNNING handleMouseOver()');
    let element = document.getElementById(event.target.id);
    element.style.color = 'var(--color-main)';
  }
  
  function handleMouseLeave(event) {
    // console.log('\nAlchmizeBatches.js >>> RUNNING handleMouseLeave()');
    let element = document.getElementById(event.target.id);
    element.style.color = '#ffffff';
  }


  async function handleBatchClick(event) {
    // const element = document.getElementById(event.target.id);
    selected_BID = event.target.id;
    const access_token = await getAccessToken();
    const batch_and_avatars = await AlchmizerOperator.GETalchmizerBatch(selected_BID, access_token);
    batch_info = batch_and_avatars.batch;
    avatar_list = batch_and_avatars.avatars;
    
    console.log('batch_info', batch_info);
    console.log('avatar_list', avatar_list);
    
    document.getElementById('batchNameTitle').textContent = batch_info['name'];
    document.getElementById('batchInfoDate').textContent = formatDate(batch_info['createdAt']);
    document.getElementById('batchInfoCreator').textContent = batch_info['creator_email'];
    document.getElementById('batchInfoQuantityGenerated').textContent = batch_info['quantity_generated'];
    document.getElementById('batchInfoTotalQuantity').textContent = batch_info['total_quantity'];
    document.getElementById('batchInfoArchitecture').textContent = batch_info['start']['imaginizer_info']['architecture'];
    document.getElementById('batchInfoBirthday').textContent = formatDate(avatar_list[avatar_list.length - 1]['alchm_info']['birth_info']['ISO']);
    document.getElementById('batchInfoLatitude').textContent = batch_info['start']['birth_info']['latitude'];
    document.getElementById('batchInfoLongitude').textContent = batch_info['start']['birth_info']['longitude'];
    document.getElementById('batchInfoModel').textContent = batch_info['start']['imaginizer_info']['model'];
    document.getElementById('batchInfoWidth').textContent = batch_info['start']['imaginizer_info']['width'];
    document.getElementById('batchInfoHeight').textContent = batch_info['start']['imaginizer_info']['height'];
    document.getElementById('batchInfoGuidanceScale').textContent = batch_info['start']['imaginizer_info']['guidance_scale'];
    document.getElementById('batchInfoInferenceSteps').textContent = batch_info['start']['imaginizer_info']['num_inference_steps'];
    

    if (batch_info['range'] === 'birthday') {
      batch_info['start'] = (Number(batch_info['start']['birth_info']['month']) + 1).toString() + '/' + batch_info['start']['birth_info']['date'] + '/' + batch_info['start']['birth_info']['year'];
      batch_info['end'] = (Number(batch_info['end']['birth_info']['month']) + 1).toString() + '/' + batch_info['end']['birth_info']['date'] + '/' + batch_info['end']['birth_info']['year'];
      batch_info['interval'] = batch_info['interval']['birth_info']['month'] + '/' + batch_info['interval']['birth_info']['date'] + '/' + batch_info['interval']['birth_info']['year'];
    };
    

    document.getElementById('batchInfoStart').textContent = batch_info['start'];
    document.getElementById('batchInfoEnd').textContent = batch_info['end'];
    document.getElementById('batchInfoInterval').textContent = batch_info['interval'];

    if (avatar_list.length > settings['images_per_page']) {
      document.getElementById('nextPageButton').style.display = 'flex';
    } else {
      document.getElementById('nextPageButton').style.display = 'none';
    };

    document.getElementById('batchListGUI').style.display = 'none';
    document.getElementById('batchGalleryGUI').style.display = 'flex';

    await populateImageContainers(batch_info, avatar_list);
  };


  async function populateImageContainers(batch_info, avatar_list) {
    for (let counter = 1; counter <= settings['images_per_page']; counter++) {
      const counter_string = counter.toString();
      const page_bonus = (gallery_page - 1) * settings['images_per_page'];

      const container = document.getElementById('container' + counter_string);
      const image = document.getElementById('image' + counter_string);
      const image_number = document.getElementById('image' + counter_string + '_number')
      const ranged_value = document.getElementById('image' + counter_string + '_rangedValue')

      if (avatar_list[counter - 1 + page_bonus]) {
        container.style.display = 'block';

        const avatar_info = avatar_list[counter - 1 + page_bonus];

        image_number.textContent = '#' + (counter + page_bonus).toString();

        // Ranged Value
        if (batch_info['range'] === 'birthday') {
          ranged_value.textContent = avatar_info['alchm_info']['birth_info']['birthday'];
        };

        image.src = avatar_info['image_URL'];
      } else {
        container.style.display = 'none';
      };
    };
  };




  async function handleGrayButtonDown(event) {
    const element = document.getElementById(event.target.id);
    element.style.backgroundColor = '#949494';
  };

  async function handleGrayButtonUp(event) {
    const element_ID = event.target.id;
    if (element_ID === 'refreshBatchListButton') {
      await fetchBatches();
    } else if (element_ID === 'refreshGalleryButton') {
      const access_token = await getAccessToken();
      const batch_and_avatars = await AlchmizerOperator.GETalchmizerBatch(selected_BID, access_token);
      batch_info = batch_and_avatars.batch;
      avatar_list = batch_and_avatars.avatars;
      document.getElementById('batchInfoQuantityGenerated').textContent = batch_info['quantity_generated'];
      await populateImageContainers(batch_info, avatar_list);
    } else if (element_ID === 'backButton') {
      document.getElementById('batchListGUI').style.display = 'flex';
      document.getElementById('batchGalleryGUI').style.display = 'none';
      await resetVariables();
      await fetchBatches();
    };
    document.getElementById(element_ID).style.backgroundColor = '#dbdbdb';
  };

  async function resetVariables() {
    selected_BID = false;
    batch_info = {};
    avatar_list = [];
    gallery_page = 1;
  };


  async function handleGalleryNavigationClick(event) {
    console.log('\nAlchmizeBatches.js >>> RUNNING handleGalleryNavigationClick()');
    const element_ID = event.target.id;
    if (element_ID === 'nextPageButton') {
      if (avatar_list.length > settings['images_per_page'] * gallery_page) {
        gallery_page++;
        await populateImageContainers(batch_info, avatar_list);
      };
    };
  };


  async function fetchBatches() {
    setLoading(true);
    setError("");

    try {
      if (!ready) throw new Error("Auth not ready yet");
      if (!authenticated) throw new Error("Not logged in");
      const access_token = await getAccessToken();
      const list = await AlchmizerOperator.GETalchmizerBatchList(access_token);
      if (!Array.isArray(list)) {
        throw new Error("Unexpected response shape: expected { batches: [...] }");
      }

      console.log(list);
      setBatches(list);
    } catch (e) {
      setError(e?.message || "Failed to load batches");
      setBatches([]);
    } finally {
      setLoading(false);
    };
  };

  useEffect(() => {
    if (ready && authenticated) fetchBatches();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ready, authenticated]);

  function formatDate(iso) {
    if (!iso) return "—";
    const d = new Date(iso);
    if (Number.isNaN(d.getTime())) return "—";
    return d.toLocaleString(undefined, {
      year: "numeric",
      month: "short",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
    });
  };











//--------------------------------------------------------------------------------------------------
//# HTML

  return (
    <div className='alchmizerBatches'>



    {/*** ---------- Batch List GUI ---------- ***/}

      <div id='batchListGUI' className='alchmizerBatches' style={{display: 'flex'}}>
      {/* ---------- Title ---------- */}
        <div className='alchmizerBatchesbannerTitleContainer' id='banner_alchmizerBatchesTitleContainer' >
          <span className='alchmizerBatchesbannerTitle' id="banner_alchmizerBatchesTitleContainer">
            Alchmizer Batches
          </span>
        </div>


        {/* ---------- Refresh Button ---------- */}
        <div className='alchmizerBatchesRefreshButtonContainer'>
          <button className="alchmizerBatchesRefreshButton" id='refreshBatchListButton' onMouseDown={handleGrayButtonDown} onMouseUp={handleGrayButtonUp} onTouchStart={handleGrayButtonDown} onTouchEnd={handleGrayButtonUp}
            disabled={loading || !ready || !authenticated}>
              {loading ? "Loading…" : "Refresh"}
          </button>
        </div>


        {/* ---------- Loading State Logic ---------- */}
        {!ready && <div className="alchmizerBatchesHint">Auth is initializing…</div>}
        {ready && !authenticated && (
          <div className="alchmizerBatchesHint">Log in to view batches.</div>
        )}
        {error && <div className="alchmizerBatchesError">{error}</div>}
        {ready && authenticated && !loading && !error && sortedBatches.length === 0 && (
          <div className="alchmizerBatchesEmpty">No batches yet.</div>
        )}


        {/* ---------- Batch List ---------- */}
        {sortedBatches.length > 0 && (
          <ul className="alchmizerBatchesBatchList">
            {/* ---------- Column Names ---------- */}
            <div className="alchmizerBatchesBatchEntry alchmizerBatchesColumnNameContainer">
              <div className="alchmizerBatchesBatchListText alchmizerBatchesColumnName"
              style={{width: "200px"}}>
                Batch Name
              </div>
              <div className="alchmizerBatchesBatchListText alchmizerBatchesColumnName" style={{width: "400px"}}>
                Date Created
              </div>
              <div className="alchmizerBatchesBatchListText alchmizerBatchesColumnName" style={{width: "100px"}}>
                Quantity
              </div>
            </div>
            {/* ---------- Batches ---------- */}
            {sortedBatches.map((b) => (
              <li key={b.BID} className="alchmizerBatchesBatchEntry">
                <div className="alchmizerBatchesBatchListText" id={b.BID} onClick={handleBatchClick} onMouseOver={handleMouseOver} onMouseLeave={handleMouseLeave}
                style={{width: "200px", cursor: "pointer", textDecoration: "underline"}}>
                  {b.name || "Untitled batch"}
                </div>
                <div className="alchmizerBatchesBatchListText" style={{width: "400px"}}>
                  {formatDate(b.createdAt)}
                </div>
                <div className="alchmizerBatchesBatchListText" style={{width: "100px"}}>
                  {b.quantity_generated || "ERROR"}/{b.total_quantity || "ERROR"}
                </div>
              </li>
            ))}
          </ul>
        )}
      </div>




    {/*** ---------- Batch Gallery GUI ---------- ***/}

      <div id='batchGalleryGUI' className='alchmizerBatches' style={{display: 'none'}}>
      {/* ---------- Title ---------- */}
        <div className='alchmizerBatchesbannerTitleContainer' id='banner_alchmizerBatchesTitleContainer' >
          <span className='alchmizerBatchesbannerTitle' id="batchNameTitle">
            batch name
          </span>
        </div>


        {/* ---------- Refresh Button ---------- */}
        <div className='alchmizerBatchesRefreshButtonContainer'>
          <button className="alchmizerBatchesRefreshButton" id='refreshGalleryButton' onMouseDown={handleGrayButtonDown} onMouseUp={handleGrayButtonUp} onTouchStart={handleGrayButtonDown} onTouchEnd={handleGrayButtonUp}
            disabled={loading || !ready || !authenticated}>
              {loading ? "Loading…" : "Refresh"}
          </button>
        </div>


        {/* ---------- Back Button ---------- */}
        <div className='alchmizerBatchesBackButtonContainer'>
          <button className="alchmizerBatchesRefreshButton" id='backButton' onMouseDown={handleGrayButtonDown} onMouseUp={handleGrayButtonUp} onTouchStart={handleGrayButtonDown} onTouchEnd={handleGrayButtonUp}>
            Back to List
          </button>
        </div>


        {/* ---------- Batch Creator Info ---------- */}
        <div className='alchmizerBatchesInfoRow'>
          <div className='alchmizerBatchesBatchInfoContainer'>
            <div className='alchmizerBatchesBatchInfoText alchmizerBatchesBatchInfoLabel'>
              Date:
            </div>
            <div className='alchmizerBatchesBatchInfoText alchmizerBatchesBatchInfoValue' id='batchInfoDate'>
              date
            </div>
          </div>
          <div className='alchmizerBatchesBatchInfoContainer'>
            <div className='alchmizerBatchesBatchInfoText alchmizerBatchesBatchInfoLabel'>
              Creator:
            </div>
            <div className='alchmizerBatchesBatchInfoText alchmizerBatchesBatchInfoValue' id='batchInfoCreator'>
              creator
            </div>
          </div>
          <div className='alchmizerBatchesBatchInfoContainer'>
            <div className='alchmizerBatchesBatchInfoText alchmizerBatchesBatchInfoLabel'>
              Quantity:
            </div>
            <div className='alchmizerBatchesBatchInfoText alchmizerBatchesBatchInfoValue' id='batchInfoQuantityGenerated'>
              generated
            </div>
            <div className='alchmizerBatchesBatchInfoText'>
              /
            </div>
            <div className='alchmizerBatchesBatchInfoText alchmizerBatchesBatchInfoValue' id='batchInfoTotalQuantity'>
              total
            </div>
          </div>
        </div>


        {/* ---------- Birth Info ---------- */}
        <div className='alchmizerBatchesInfoRow'>
          <div className='alchmizerBatchesBatchInfoContainer'>
            <div className='alchmizerBatchesBatchInfoText alchmizerBatchesBatchInfoLabel'>
              Architecture:
            </div>
            <div className='alchmizerBatchesBatchInfoText alchmizerBatchesBatchInfoValue' id='batchInfoArchitecture'>
              architecture
            </div>
          </div>
          <div className='alchmizerBatchesBatchInfoContainer'>
            <div className='alchmizerBatchesBatchInfoText alchmizerBatchesBatchInfoLabel'>
              Birthday:
            </div>
            <div className='alchmizerBatchesBatchInfoText alchmizerBatchesBatchInfoValue' id='batchInfoBirthday'>
              birthday
            </div>
          </div>
          <div className='alchmizerBatchesBatchInfoContainer'>
            <div className='alchmizerBatchesBatchInfoText alchmizerBatchesBatchInfoLabel'>
              Location:
            </div>
            <div className='alchmizerBatchesBatchInfoText alchmizerBatchesBatchInfoValue' id='batchInfoLatitude'>
              latitude
            </div>
            <div className='alchmizerBatchesBatchInfoText'>
              °,
            </div>
            <div className='alchmizerBatchesBatchInfoText alchmizerBatchesBatchInfoValue' id='batchInfoLongitude'>
              longitude
            </div>
            <div className='alchmizerBatchesBatchInfoText'>
              °
            </div>
          </div>
        </div>


        {/* ---------- Image Generator Info ---------- */}
        <div className='alchmizerBatchesInfoRow'>
          <div className='alchmizerBatchesBatchInfoContainer'>
            <div className='alchmizerBatchesBatchInfoText alchmizerBatchesBatchInfoLabel'>
              Model:
            </div>
            <div className='alchmizerBatchesBatchInfoText alchmizerBatchesBatchInfoValue' id='batchInfoModel'>
              model
            </div>
          </div>
          <div className='alchmizerBatchesBatchInfoContainer'>
            <div className='alchmizerBatchesBatchInfoText alchmizerBatchesBatchInfoLabel'>
              Size:
            </div>
            <div className='alchmizerBatchesBatchInfoText alchmizerBatchesBatchInfoValue' id='batchInfoWidth'>
              width
            </div>
            <div className='alchmizerBatchesBatchInfoText'>
              x
            </div>
            <div className='alchmizerBatchesBatchInfoText alchmizerBatchesBatchInfoValue' id='batchInfoHeight'>
              height
            </div>
          </div>
          <div className='alchmizerBatchesBatchInfoContainer'>
            <div className='alchmizerBatchesBatchInfoText alchmizerBatchesBatchInfoLabel'>
              Guidance Scale:
            </div>
            <div className='alchmizerBatchesBatchInfoText alchmizerBatchesBatchInfoValue' id='batchInfoGuidanceScale'>
              model
            </div>
          </div>
          <div className='alchmizerBatchesBatchInfoContainer'>
            <div className='alchmizerBatchesBatchInfoText alchmizerBatchesBatchInfoLabel'>
              Inference Steps:
            </div>
            <div className='alchmizerBatchesBatchInfoText alchmizerBatchesBatchInfoValue' id='batchInfoInferenceSteps'>
              model
            </div>
          </div>
        </div>
          


        {/* ---------- Batch Start, End, and Interval ---------- */}
        <div className='alchmizerBatchesInfoRow'>
          <div className='alchmizerBatchesBatchInfoContainer'>
            <div className='alchmizerBatchesBatchInfoText alchmizerBatchesBatchInfoLabel'>
              Start:
            </div>
            <div className='alchmizerBatchesBatchInfoText alchmizerBatchesBatchInfoValue' id='batchInfoStart'>
              start
            </div>
          </div>
          <div className='alchmizerBatchesBatchInfoContainer'>
            <div className='alchmizerBatchesBatchInfoText alchmizerBatchesBatchInfoLabel'>
              End:
            </div>
            <div className='alchmizerBatchesBatchInfoText alchmizerBatchesBatchInfoValue' id='batchInfoEnd'>
              end
            </div>
          </div>
          <div className='alchmizerBatchesBatchInfoContainer'>
            <div className='alchmizerBatchesBatchInfoText alchmizerBatchesBatchInfoLabel'>
              Interval:
            </div>
            <div className='alchmizerBatchesBatchInfoText alchmizerBatchesBatchInfoValue' id='batchInfoInterval'>
              interval
            </div>
          </div>
        </div>


        {/* ---------- Next Page Button ---------- */}
        <div className='alchmizerBatchesGalleryNavigationContainer'>
          <span className="alchmizerBatchesBatchInfoText alchmizerBatchesBatchInfoValue" id='nextPageButton' onClick={handleGalleryNavigationClick}
          style={{cursor: 'pointer'}}>
            Next Page →
          </span>
        </div>


        {/* ---------- Images Row 1 ---------- */}
        <div className='alchmizerBatchesImageRow'>
          <div className='alchmizerBatchesImageContainer' id='container1'>
            <img src={loading_placeholder} className='alchmizerBatchesImage' id='image1' alt='1'/>
            <div className='alchmizerBatchesImageInfoContainer'>
              <div className='alchmizerBatchesBatchInfoText' id='image1_number'>
                #1
              </div>
              <div className='alchmizerBatchesBatchInfoText' id='image1_rangedValue'>
                ranged value
              </div>
            </div>
          </div>
          <div className='alchmizerBatchesImageContainer' id='container2'>
            <img src={loading_placeholder} className='alchmizerBatchesImage' id='image2' alt='2'/>
            <div className='alchmizerBatchesImageInfoContainer'>
              <div className='alchmizerBatchesBatchInfoText' id='image2_number'>
                #2
              </div>
              <div className='alchmizerBatchesBatchInfoText' id='image2_rangedValue'>
                ranged value
              </div>
            </div>
          </div>
          <div className='alchmizerBatchesImageContainer' id='container3'>
            <img src={loading_placeholder} className='alchmizerBatchesImage' id='image3' alt='3'/>
            <div className='alchmizerBatchesImageInfoContainer'>
              <div className='alchmizerBatchesBatchInfoText' id='image3_number'>
                #3
              </div>
              <div className='alchmizerBatchesBatchInfoText' id='image3_rangedValue'>
                ranged value
              </div>
            </div>
          </div>
          <div className='alchmizerBatchesImageContainer' id='container4'>
            <img src={loading_placeholder} className='alchmizerBatchesImage' id='image4' alt='4'/>
            <div className='alchmizerBatchesImageInfoContainer'>
              <div className='alchmizerBatchesBatchInfoText' id='image4_number'>
                #4
              </div>
              <div className='alchmizerBatchesBatchInfoText' id='image4_rangedValue'>
                ranged value
              </div>
            </div>
          </div>
          <div className='alchmizerBatchesImageContainer' id='container5'>
            <img src={loading_placeholder} className='alchmizerBatchesImage' id='image5' alt='5'/>
            <div className='alchmizerBatchesImageInfoContainer'>
              <div className='alchmizerBatchesBatchInfoText' id='image5_number'>
                #5
              </div>
              <div className='alchmizerBatchesBatchInfoText' id='image5_rangedValue'>
                ranged value
              </div>
            </div>
          </div>
        </div>


        {/* ---------- Images Row 2 ---------- */}
        <div className='alchmizerBatchesImageRow'>
          <div className='alchmizerBatchesImageContainer' id='container6'>
            <img src={loading_placeholder} className='alchmizerBatchesImage' id='image6' alt='6'/>
            <div className='alchmizerBatchesImageInfoContainer'>
              <div className='alchmizerBatchesBatchInfoText' id='image6_number'>
                #6
              </div>
              <div className='alchmizerBatchesBatchInfoText' id='image6_rangedValue'>
                ranged value
              </div>
            </div>
          </div>
          <div className='alchmizerBatchesImageContainer' id='container7'>
            <img src={loading_placeholder} className='alchmizerBatchesImage' id='image7' alt='7'/>
            <div className='alchmizerBatchesImageInfoContainer'>
              <div className='alchmizerBatchesBatchInfoText' id='image7_number'>
                #7
              </div>
              <div className='alchmizerBatchesBatchInfoText' id='image7_rangedValue'>
                ranged value
              </div>
            </div>
          </div>
          <div className='alchmizerBatchesImageContainer' id='container8'>
            <img src={loading_placeholder} className='alchmizerBatchesImage' id='image8' alt='8'/>
            <div className='alchmizerBatchesImageInfoContainer'>
              <div className='alchmizerBatchesBatchInfoText' id='image8_number'>
                #8
              </div>
              <div className='alchmizerBatchesBatchInfoText' id='image8_rangedValue'>
                ranged value
              </div>
            </div>
          </div>
          <div className='alchmizerBatchesImageContainer' id='container9'>
            <img src={loading_placeholder} className='alchmizerBatchesImage' id='image9' alt='9'/>
            <div className='alchmizerBatchesImageInfoContainer'>
              <div className='alchmizerBatchesBatchInfoText' id='image9_number'>
                #9
              </div>
              <div className='alchmizerBatchesBatchInfoText' id='image9_rangedValue'>
                ranged value
              </div>
            </div>
          </div>
          <div className='alchmizerBatchesImageContainer' id='container10'>
            <img src={loading_placeholder} className='alchmizerBatchesImage' id='image10' alt='10'/>
            <div className='alchmizerBatchesImageInfoContainer'>
              <div className='alchmizerBatchesBatchInfoText' id='image10_number'>
                #10
              </div>
              <div className='alchmizerBatchesBatchInfoText' id='image10_rangedValue'>
                ranged value
              </div>
            </div>
          </div>
        </div>


        {/* ---------- Images Row 3 ---------- */}
        <div className='alchmizerBatchesImageRow'>
          <div className='alchmizerBatchesImageContainer' id='container11'>
            <img src={loading_placeholder} className='alchmizerBatchesImage' id='image11' alt='11'/>
            <div className='alchmizerBatchesImageInfoContainer'>
              <div className='alchmizerBatchesBatchInfoText' id='image11_number'>
                #11
              </div>
              <div className='alchmizerBatchesBatchInfoText' id='image11_rangedValue'>
                ranged value
              </div>
            </div>
          </div>
          <div className='alchmizerBatchesImageContainer' id='container12'>
            <img src={loading_placeholder} className='alchmizerBatchesImage' id='image12' alt='12'/>
            <div className='alchmizerBatchesImageInfoContainer'>
              <div className='alchmizerBatchesBatchInfoText' id='image12_number'>
                #12
              </div>
              <div className='alchmizerBatchesBatchInfoText' id='image12_rangedValue'>
                ranged value
              </div>
            </div>
          </div>
          <div className='alchmizerBatchesImageContainer' id='container13'>
            <img src={loading_placeholder} className='alchmizerBatchesImage' id='image13' alt='13'/>
            <div className='alchmizerBatchesImageInfoContainer'>
              <div className='alchmizerBatchesBatchInfoText' id='image13_number'>
                #13
              </div>
              <div className='alchmizerBatchesBatchInfoText' id='image13_rangedValue'>
                ranged value
              </div>
            </div>
          </div>
          <div className='alchmizerBatchesImageContainer' id='container14'>
            <img src={loading_placeholder} className='alchmizerBatchesImage' id='image14' alt='14'/>
            <div className='alchmizerBatchesImageInfoContainer'>
              <div className='alchmizerBatchesBatchInfoText' id='image14_number'>
                #14
              </div>
              <div className='alchmizerBatchesBatchInfoText' id='image14_rangedValue'>
                ranged value
              </div>
            </div>
          </div>
          <div className='alchmizerBatchesImageContainer' id='container15'>
            <img src={loading_placeholder} className='alchmizerBatchesImage' id='image15' alt='15'/>
            <div className='alchmizerBatchesImageInfoContainer'>
              <div className='alchmizerBatchesBatchInfoText' id='image15_number'>
                #15
              </div>
              <div className='alchmizerBatchesBatchInfoText' id='image15_rangedValue'>
                ranged value
              </div>
            </div>
          </div>
        </div>



        {/* ---------- Images Row 4 ---------- */}
        <div className='alchmizerBatchesImageRow'>
          <div className='alchmizerBatchesImageContainer' id='container16'>
            <img src={loading_placeholder} className='alchmizerBatchesImage' id='image16' alt='16'/>
            <div className='alchmizerBatchesImageInfoContainer'>
              <div className='alchmizerBatchesBatchInfoText' id='image16_number'>
                #16
              </div>
              <div className='alchmizerBatchesBatchInfoText' id='image16_rangedValue'>
                ranged value
              </div>
            </div>
          </div>
          <div className='alchmizerBatchesImageContainer' id='container17'>
            <img src={loading_placeholder} className='alchmizerBatchesImage' id='image17' alt='17'/>
            <div className='alchmizerBatchesImageInfoContainer'>
              <div className='alchmizerBatchesBatchInfoText' id='image17_number'>
                #17
              </div>
              <div className='alchmizerBatchesBatchInfoText' id='image17_rangedValue'>
                ranged value
              </div>
            </div>
          </div>
          <div className='alchmizerBatchesImageContainer' id='container18'>
            <img src={loading_placeholder} className='alchmizerBatchesImage' id='image18' alt='18'/>
            <div className='alchmizerBatchesImageInfoContainer'>
              <div className='alchmizerBatchesBatchInfoText' id='image18_number'>
                #18
              </div>
              <div className='alchmizerBatchesBatchInfoText' id='image18_rangedValue'>
                ranged value
              </div>
            </div>
          </div>
          <div className='alchmizerBatchesImageContainer' id='container19'>
            <img src={loading_placeholder} className='alchmizerBatchesImage' id='image19' alt='19'/>
            <div className='alchmizerBatchesImageInfoContainer'>
              <div className='alchmizerBatchesBatchInfoText' id='image19_number'>
                #19
              </div>
              <div className='alchmizerBatchesBatchInfoText' id='image19_rangedValue'>
                ranged value
              </div>
            </div>
          </div>
          <div className='alchmizerBatchesImageContainer' id='container20'>
            <img src={loading_placeholder} className='alchmizerBatchesImage' id='image20' alt='20'/>
            <div className='alchmizerBatchesImageInfoContainer'>
              <div className='alchmizerBatchesBatchInfoText' id='image20_number'>
                #20
              </div>
              <div className='alchmizerBatchesBatchInfoText' id='image20_rangedValue'>
                ranged value
              </div>
            </div>
          </div>
        </div>


      </div>
    </div>
  );
}